/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".machine-picker[_ngcontent-%COMP%]{width:100%}.machine-edit-button[_ngcontent-%COMP%]{max-width:36px}.machine-item[_ngcontent-%COMP%]{height:100px;background-position:center;background-repeat:no-repeat;max-width:400px}.ellipsis[_ngcontent-%COMP%]{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}"];
export { styles as styles };
